import React from "react";
import {
  Radio,
  TextField,
  IconButton,
  Button,
  ClickAwayListener,
  Dialog,
} from "@material-ui/core";
import convertPersianToEnglishNumber from "../../../../../utils/convert-persian-to-english-number";
import { Add, CompareArrows, Remove } from "@material-ui/icons";
import { getAllTownshipsGroup } from "./cruds";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actions } from "./redux";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import { actions as searchActions } from "../../../../SearchPage/_redux/searchRedux";
import { search_travel } from "../../../../SearchPage/_redux/searchCrud";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import jalaali from "jalaali-js";
import fixNumbers from "../../../../../../functions/fixNumbers";
import { actions as resAct } from "../../../../ReservePage/_redux/reserveRedux";
import { actions as townshipAction } from "./redux";
import { Select } from "antd";
import { useMediaQuery } from "react-responsive";
import { actions as homepageActions } from "../../../_redux/homepageRedux";
import { withStyles } from "@material-ui/core";
import moment from "moment-jalaali";

const { Option, OptGroup } = Select;

const SearchSectionForms = (props) => {
  const [bigCount, setBigCount] = React.useState(1);
  const [smallCount, setSmallCount] = React.useState(0);
  const [panelShow, setPanelShow] = React.useState(false);
  const [isSimple, setIsSimple] = React.useState("0");
  const [dest, setDest] = React.useState(null);
  const [source, setSource] = React.useState(null);
  const [returnDate, setReturnDate] = React.useState(null);
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [isSub, setIsSub] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [towns, setTowns] = React.useState(null);
  const [townsDest, setTownsDest] = React.useState(null);
  const [selSrc, setSelSrc] = React.useState(null);
  const [selDest, setSelDest] = React.useState(null);

  let { state } = useSelector(
    (state) => ({
      state: state.townships,
    }),
    shallowEqual
  );

  const handleSrcVal = (value) => {
    setSelSrc(value);
  };
  const handleDestVal = (value) => {
    setSelDest(value);
  };

  const { townships } = state;

  React.useEffect(() => {
    getAllTownshipsGroup().then((res) => {
      setTowns(res.data.data);
      setTownsDest(res.data.data);
      dispatch(actions.getAllTownshipsGroup(res.data.data));
    });

    if (props.date2) {
      setIsSimple("1");
    } else {
      setIsSimple("0");
    }

    const persianDate = props.date
      ? fixNumbers(new Date(props.date).toLocaleDateString("fa-IR")).split("/")
      : null;

    if ((persianDate[0], persianDate[1], persianDate[2])) {
      setSelectedDay({
        year: +persianDate[0],
        month: +persianDate[1],
        day: +persianDate[2],
      });
    }

    setReturnDate(props.date2);
    const seatCount = props.count.split(",");
    const count = Number(seatCount[0]) + Number(seatCount[1]);
    setBigCount(count);

    setSmallCount(state.smallCount);
  }, []);

  const destValueSetter = (id) => {
    townships.map((el) => {
      const filtered = el.Townships.filter((town) => {
        return town.persianTitle === id;
      });

      if (filtered.length !== 0) {
        setDest(filtered[0]);
        setSelDest(filtered[0].persianTitle);
      }
    });
  };

  const sourceValueSetter = (id) => {
    townships.map((el) => {
      const filtered = el.Townships.filter((town) => {
        return town.persianTitle === id;
      });

      if (filtered.length !== 0) {
        setSource(filtered[0]);
        setSelSrc(filtered[0].persianTitle);
      }
    });
  };

  const renderCustomInput = ({ ref }) => {
    return (
      <>
        <input
          onClick={() => {
            // if (!isMobile) {
            //   Scroll.scroller.scrollTo("datepicker-scroll", {
            //     duration: 800,
            //     delay: 0,
            //     smooth: "easeInOutQuart",
            //   });
            // }
          }}
          readOnly
          placeholder="تاریخ را انتخاب کنید"
          value={
            selectedDay
              ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
              : ""
          }
          ref={ref}
          style={{
            textAlign: "right",
            padding: "1.9rem 1rem",
            fontSize: "1rem",
            border: "1px solid #d9d9d9",
            width: "100%",
            borderRadius: "12px",
            color: "currentColor",
            height: "48px",
            outline: "none",
            backgroundColor: "white",
          }}
          className="my-custom-input-class datepicker-scroll" // a styling class
          id="departuredDateRef"
        />
      </>
    );
  };

  // const renderDisabledCustomInput = ({ ref }) => {
  //   return (
  //     <input
  //       readOnly
  //       placeholder="تاریخ را انتخاب کنید"
  //       value={
  //         selectedDay
  //           ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
  //           : ""
  //       }
  //       disabled
  //       ref={ref}
  //       style={{
  //         textAlign: "right",
  //         padding: "1.9rem 1rem",
  //         fontSize: "1rem",
  //         border: "1px solid rgb(230 230 230 / 1)",
  //         width: "100%",
  //         borderRadius: "12px",
  //         color: "rgb(230 230 230 / 1)",
  //         height: "48px",
  //         outline: "none",
  //         backgroundColor: "white",
  //       }}
  //       className="my-custom-input-class date-picker-input" // a styling class
  //     />
  //   );
  // };

  // const yupValidationSchema = Yup.object().shape({
  //   source: Yup.number()
  //     .notOneOf([Yup.ref("destination")], "مقصد و مبدا همسانند!")
  //     .required(),
  //   destination: Yup.number()
  //     .notOneOf([Yup.ref("source")], "مقصد و مبدا همسانند!")
  //     .required(),useState
  //   departuredDate: Yup.date().required(),
  //   returnDate: Yup.date().when(isSimple, {
  //     is: "1",
  //     then: Yup.date().required(),
  //     otherwise: null,
  //   }),
  // });

  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "#d9d9d9d",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#d9d9d9d",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: panelShow ? "#6dd06d" : "#d9d9d9",
        },
        "&:hover fieldset": {
          borderColor: "#6dd06d",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#d9d9d9d",
        },
      },
    },
  })(TextField);

  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  React.useEffect(() => {
    if (townships.length !== 0 && !selDest && !selSrc && !isSubmitted) {
      destValueSetter(props.dest_id);
      sourceValueSetter(props.source_id);
      setIsSubmitted(true);
    }
    if (selSrc && selDest && !isSub) {
      dispatch(townshipAction.setSrcAndDestTitle({ source, dest }));
      setIsSub(true);
    }
  });

  return (
    <Formik
      enableReinitialize
      // validationSchema={yupValidationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={{
        departuredDate: props.date,
        destination: { persianTitle: selDest, id: dest?.id },
        source: { persianTitle: selSrc, id: source?.id },
        
      }}
      onSubmit={(values) => {
        const keys = Object.keys(values);
     
        // const newDate = jalaali
        //   .jalaaliToDateObject(
        //     selectedDay?.year,
        //     selectedDay?.month,
        //     selectedDay?.day
        //   )
        //   .toLocaleDateString()
        //   .split("/");

        // const georgianDate = new Date(
        //   `${+newDate[2]}-${
        //     +newDate[0] < 10 ? `0${+newDate[0]}` : +newDate[0]
        //   }-${+newDate[1] < 10 ? `0${+newDate[1]}` : +newDate[1]}`
        // );

        // dispatch(
        //   resAct.setTabsDate(`${+newDate[2]}-${+newDate[0]}-${+newDate[1]}`)
        // );

        // // georgianDate.setDate(georgianDate.getDate() + 1);

        // const year = georgianDate.getUTCFullYear();
        // const month = +georgianDate.getUTCMonth() + 1;
        // const day = georgianDate.getUTCDate();
        // const valMonth = month < 10 ? `0${month}` : month;
        // const valDay = day < 10 ? `0${day}` : day;

        // const depDate = `${year}-${valMonth}-${valDay}`;

        moment.loadPersian({usePersianDigits: false})
        const georgianDate  = moment(`${+selectedDay.year}-${selectedDay.month}-${selectedDay.day}`, 'jYYYY-jM-jD').format('YYYY-MM-DD')
        const depDate = georgianDate;
        dispatch(resAct.setFirstTabsDate(depDate));
        dispatch(resAct.setTabsDate(depDate));

        keys.map((el) => {
          if (!values[el]) {
            delete values[el];
            dispatch(actions[el](undefined));
          } else {
            dispatch(actions[el](values[el]));
          }
        });

        dispatch(townshipAction.setSrcAndDestTitle({ source, dest }));
        dispatch(searchActions.loadTravels([]));
        dispatch(resAct.setMockTravels([]));
        dispatch(resAct.setLoadingStats(undefined));
        // console.log("ssss",values);
        search_travel(selSrc, selDest, depDate, bigCount + smallCount )
          .then((res) => {
            dispatch(searchActions.loadTravels(res.data.data));
            dispatch(resAct.setMockTravels(res.data.data));
            if (res.data.data.length === 0) {
              dispatch(resAct.setLoadingStats("0"));
            } else {
              dispatch(resAct.setLoadingStats("1"));
            }
          })
          .catch(() => {
            dispatch(searchActions.loadTravels([]));
            dispatch(resAct.setMockTravels([]));
            dispatch(resAct.setLoadingStats("-1"));
          });

        if (isSimple === "1") {
          history.push(
            `/bus-ticket/${values.source.persianTitle}/${values.destination.persianTitle}?date=${returnDate},${depDate}&count=${bigCount},${smallCount}`
          );
        } else if (isSimple === "0") {
          history.push(
            `/bus-ticket/${values.source.persianTitle}/${values.destination.persianTitle}?date=${depDate}&count=${bigCount},${smallCount}`
          );
        }
      }}
    >
      {({ handleSubmit, setFieldValue, isValid, values }) => {
        return (
          <div
            className=" bg-white d-block h-auto p-5 container"
            style={{
              // marginTop: !isMobile ? "10%" : null,
              // minHeight: "43%",
              borderRadius: 20,
              boxShadow: !isMobile ? "0px 3px 10px 0px #d8d1d1" : null,
            }}
          >
            <div className="row container align-items-center mr-2">
              <Radio
                checked={isSimple === "0"}
                value="0"
                style={{ color: "green" }}
                onChange={() => setIsSimple("0")}
              />
              <label
                style={{ fontSize: "18px" }}
                className="align-self-flex-end"
              >
                یک طرفه
              </label>
            </div>

            <div
              className="d-flex flex-wrap w-100 p-1  align-items-center"
              style={{ justifyContent: "space-around" }}
            >
              <div
                className="col-lg-2 col-sm-6"
                style={{ marginBlock: 13.5, height: "50px" }}
              >
                {/* {autoDis ? (
                  <Autocomplete
                    value={source}
                    style={{ width: "100%" }}
                    id="desctination-select"
                    options={townships}
                    onChange={(e, a) => {
                      if (a) {
                        setSource(a);
                        dispatch(actions.setSrcId(a.id));
                        setFieldValue("source", a);
                      } else {
                        setSource(null);
                        dispatch(actions.setSrcId(null));
                        setFieldValue("source", null);
                      }
                    }}
                    noOptionsText={"هیج نتیجه ای یافت نشد"}
                    getOptionLabel={(option) => option.title}
                    renderOption={(option) => {
                      return option.title;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<span>مبدا حرکت</span>}
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "off",
                        }}
                      />
                    )}
                  />
                ) : (
                  <TextField
                    label={<span>مبدا حرکت</span>}
                    variant="outlined"
                  />
                )} */}
                <Select
                  showSearch
                  optionFilterProp="children"
                  style={{ borderRadius: "13px" }}
                  className="w-100 h-100"
                  onChange={(e, a) => {
                    handleSrcVal(e);
                    setSource({
                      persianTitle: a.persianTitle,
                      id: a.id,
                      code: a.code,
                    });
                    setFieldValue("source", { persianTitle: e, id: a.id });
                    window.localStorage.setItem("srcId", a.id);
                  }}
                  // onChange={handleSearch}
                  value={selSrc}
                  placeholder={
                    <span
                      className="d-flex align-items-center"
                      style={{ gap: "5px" }}
                    >
                      <h5 className="mx-auto my-auto text-muted">مبدا</h5>
                    </span>
                  }
                >
                  {towns
                    ? towns.map((province) => {
                        return (
                          <OptGroup label={province.title}>
                            {province.Townships.map((towns) => {
                                 if (selDest!=towns.persianTitle) {
                                  return (
                                    <Option
                                      value={towns.persianTitle}
                                      id={towns.id}
                                      persianTitle={towns.persianTitle}
                                    >
                                      <i
                                        className="fa fa-map-marker"
                                        style={{ fontSize: 15, color: "#6dd06d" }}
                                      ></i>{" "}
                                      {towns.title}
                                    </Option>
                                  );
                                 }
                       
                            })}
                          </OptGroup>
                        );
                      })
                    : []}
                </Select>
                <div
                  onClick={() => {
                    if (!selDest || !selSrc) {
                      return false;
                    } else {
                      const src3 = dest ? dest : null;
                      const dest3 = source ? source : null;
                      const src1 = selDest ? selDest : null;
                      const src2 = values.destination
                        ? values.destination
                        : null;
                      const newDest = selSrc ? selSrc : null;
                      const newDest2 = values.source ? values.source : null;
                      setFieldValue("destination", newDest2);
                      setFieldValue("source", src2);
                      setSource(src3);
                      setDest(dest3);
                      setSelDest(newDest);
                      setSelSrc(src1);
                      dispatch(actions.setSrcId(src1.id));
                      dispatch(actions.setDestId(newDest.id));

                      window.localStorage.setItem("destId", src2.id);
                      window.localStorage.setItem("srcId", newDest2.id);
                    }
                  }}
                >
                  {/* <CompareArrows
                    className="d-block d-lg-none text-white"
                    style={{
                      position: "absolute",
                      left: "-6%",
                      top: "5%",
                      borderRadius: "100rem",
                      zIndex: 1,

                      fontSize: "3.5rem",
                      backgroundColor: "#6dd06d",
                    }}
                  /> */}
                  <CompareArrows
                    className="d-flex align-self-center justify-self-center"
                    style={{
                      position: "absolute",
                      left: "8%",
                      top: "25%",
                      borderRadius: "100rem",
                      fontSize: "2rem",
                      zIndex: 1,
                      color: "#6dd06d",
                    }}
                  />
                </div>
              </div>
              <div
                className="col-lg-2 col-sm-6"
                style={{ marginBlock: 13.5, height: "50px" }}
              >
                <Select
                  showSearch
                  className="w-100 h-100"
                  style={{ borderRadius: "13px" }}
                  optionFilterProp="children"
                  onChange={(e, a) => {
                    handleDestVal(e);
                    setDest({
                      persianTitle: a.persianTitle,
                      code: a.code,
                      id: a.id,
                    });
                    setFieldValue("destination", { persianTitle: e, id: a.id });
                    window.localStorage.setItem("destId", a.id);
                  }}
                  // onSearch={handleSearch2}
                  value={selDest}
                  placeholder={
                    <span
                      className="d-flex align-items-center"
                      style={{ gap: "5px" }}
                    >
                      <h5 className="mx-auto my-auto text-muted">مقصد</h5>
                    </span>
                  }
                >
                  {townsDest
                    ? townsDest.map((province) => {
                        return (
                          <OptGroup label={province.title}>
                            {province.Townships.map((towns) => {
                              if (selSrc!=towns.persianTitle) {
                                return (
                                  <Option
                                    value={towns.persianTitle}
                                    id={towns.id}
                                    persianTitle={towns.persianTitle}
                                  >
                                    <i
                                      className="fa fa-map-marker"
                                      style={{ fontSize: 15, color: "#6dd06d" }}
                                    ></i>{" "}
                                    {towns.title}
                                  </Option>
                                );
                              }
                 
                            })}
                          </OptGroup>
                        );
                      })
                    : []}
                </Select>
                {/* {autoDis ? (
                  <Autocomplete
                    className="w-100"
                    value={dest}
                    onChange={(e, a) => {
                      if (a) {
                        dispatch(actions.setDestId(a.id));
                        setDest(a);
                        setFieldValue("destination", a);
                      } else {
                        dispatch(actions.setDestId(null));
                        setDest(null);
                        setFieldValue("destination", null);
                      }
                    }}
                    id="desctination-select"
                    options={townships}
                    noOptionsText={"هیج نتیجه ای یافت نشد"}
                    getOptionLabel={(option) => option.title}
                    renderOption={(option) => {
                      return option.title;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<span>مقصد حرکت</span>}
                        variant="outlined"
                      />
                    )}
                  />
                ) : (
                  <TextField
                    label={<span>مقصد حرکت</span>}
                    variant="outlined"
                  />
                )} */}
              </div>
              <div className={`col-lg-2 col-12`} style={{ marginBlock: 13.5 }}>
                {/* <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  calendarPopperPosition="bottom"
                  name="departureDate"
                  shouldHighlightWeekends
                  renderInput={renderCustomInput}
                  minimumDate={utils("fa").getToday()}
                  style={{ height: "45px", width: "100%" }}
                  locale="fa"
                /> */}
                <DatePicker
                  value={selectedDay}
                  calendarPopperPosition="bottom"
                  onChange={(e) => {
                    setSelectedDay(e);
                    // setFieldValue("departureDate", e);
                  }}
                  name="departureDate"
                  // ref={departuredDateRef}
                  shouldHighlightWeekends
                  renderInput={renderCustomInput}
                  minimumDate={utils("fa").getToday()}
                  style={{ height: "45px", width: "100%" }}
                  locale="fa"
                />

                {/* <DatePicker
                  className="w-100 h-100"
                  name="departureDatetime"
                  timePicker={false}
                  value={convertToJalali(props.date)}
                  className="form-control"
                  onClickSubmitButton={(event) => {
                    if (event.value._i) {
                      let splittedDate = event.value._i.split("-");
                      setDate(
                        `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}`
                      );
                      setFieldValue(
                        "departuredDate",
                        `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}`
                      );
                    }
                  }}
                /> */}
              </div>
              {/* {isSimple === "1" ? (
                <div className="col-lg-2 col-6" style={{ marginBlock: 13.5 }}>
                  <DatePicker
                    value={selectedDay}
                    name="departureDatetime"
                    calendarPopperPosition="bottom"
                    onChange={setSelectedDay}
                    shouldHighlightWeekends
                    renderInput={renderCustomInput}
                    minimumDate={utils("fa").getToday()}
                    locale="fa"
                  />
                </div>
              ) : (
                <div className="col-lg-2 col-6" style={{ marginBlock: 13.5 }}>
                  <DatePicker
                    value={selectedDay}
                    name="departureDatetime"
                    calendarPopperPosition="bottom"
                    onChange={setSelectedDay}
                    shouldHighlightWeekends
                    renderInput={renderDisabledCustomInput}
                    minimumDate={utils("fa").getToday()}
                    locale="fa"
                  />
                </div>
              )} */}
              <div className={`col-lg-2`} style={{ marginBlock: 13.5 }}>
                <TextField
                  className="d-block w-100"
                  onClick={() => setPanelShow(true)}
                  
                  // label={<span>تعداد مسافران</span>}
                  // value={bigCount + " بزرگسال،" + smallCount + " کودک "}
                  value={bigCount + " بزرگسال"}
                  variant="outlined"
                  inputProps={{
                    autoComplete: "new-password",
                  }}
                />
                {panelShow ? (
                  <>
                    {isMobile ? (
                      <Dialog
                        open={panelShow}
                        PaperProps={{
                          style: {
                            position: "absolute",
                            bottom: "0",
                            height: "auto",
                            minWidth: "100%",
                            margin: "0",
                          },
                          className: "count-modal",
                        }}
                        fullWidth
                      >
                        <div className="d-flex flex-wrap mx-auto p-5">
                          <div
                            className="col-12 mt-2 mb-5"
                            style={{ gap: "5px", fontSize: "17px" }}
                          >
                            <span>تعداد مسافران:</span>
                            <span style={{ color: "#6dd06d" }}>
                              {" "}
                              {+smallCount + +bigCount}
                            </span>
                          </div>
                          <div
                            className="col-6 d-flex flex-column align-items-center"
                            style={{ gap: "20px" }}
                          >
                            <IconButton
                              style={{
                                border: "1px solid #6dd06d",
                                width: "4rem",
                                height: "4rem",
                                borderRadius: "150rem",
                                color: "#6dd06d",
                              }}
                              onClick={() => {
                                if (+bigCount + +smallCount <5) {
                                  setBigCount(+bigCount + 1);
                                }
                              }}
                            >
                              <Add className="mx-auto my-auto" />
                            </IconButton>
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: "10px", fontSize: "17px" }}
                            >
                              <span style={{ color: "#6dd06d" }}>
                                {bigCount}
                              </span>
                              <span>بزرگسال</span>
                            </div>
                            <IconButton
                              style={{
                                border: "1px solid #6dd06d",
                                width: "4rem",
                                height: "4rem",
                                borderRadius: "150rem",
                                color: "#6dd06d",
                              }}
                              onClick={() => {
                                if (+bigCount - 1 < 1) {
                                  return false;
                                } else {
                                  setBigCount(+bigCount - 1);
                                  // setFieldValue("adultCount", bigCount);
                                }
                              }}
                            >
                              <Remove className="mx-auto my-auto" />
                            </IconButton>
                          </div>
                          <div
                            className="col-6 d-flex flex-column align-items-center"
                            style={{ gap: "20px" }}
                          >
                            <IconButton
                              style={{
                                border: "1px solid #6dd06d",
                                width: "4rem",
                                height: "4rem",
                                borderRadius: "150rem",
                                color: "#6dd06d",
                              }}
                              onClick={() => {
                                if (+bigCount + +smallCount <5) {
                                  setSmallCount(+smallCount + 1);
                                }
                              }}
                            >
                              <Add className="mx-auto my-auto" />
                            </IconButton>
                            {/* <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: "10px", fontSize: "17px" }}
                            >
                              {" "}
                              <span style={{ color: "#6dd06d" }}>
                                {smallCount}
                              </span>
                              <span>کودک</span>
                            </div> */}
                            <IconButton
                              style={{
                                border: `1px solid #6dd06d`,
                                width: "4rem",
                                height: "4rem",
                                borderRadius: "150rem",
                                color: "#6dd06d",
                              }}
                              onClick={() => {
                                if (+smallCount - 1 < 0) {
                                  return false;
                                } else {
                                  setSmallCount(+smallCount - 1);
                                  // setFieldValue("adultCount", bigCount);
                                }
                              }}
                            >
                              <Remove className="mx-auto my-auto" />
                            </IconButton>
                          </div>
                          <div
                            className="col-12 mb-2 mt-5"
                            style={{ height: "4rem" }}
                          >
                            <Button
                              className="w-100 h-100"
                              style={{
                                borderRadius: "10px",
                                border: "1px solid #6dd06d",
                                backgroundColor: "#6dd06d",
                              }}
                              onClick={() => {
                                setPanelShow(false);
                              }}
                            >
                              <h6 className="mx-auto my-auto text-white">
                                تایید
                              </h6>
                            </Button>
                          </div>
                        </div>
                      </Dialog>
                    ) : (
                      <ClickAwayListener
                        onClickAway={() => setPanelShow(!panelShow)}
                      >
                        <div
                          id="passengers-container-search"
                          style={{
                            width: !isTabletOrMobile && "30rem",
                          }}
                        >
                          <div className="row">
                            <div className="col-sm-12 col-xs-12 pr-0 type-holder">
                              <div className="row">
                                <div className="col-sm-6 col-xs-6">
                                  <h5 className="mt-4">بزرگسال</h5>
                                </div>
                                <div
                                  className="col-sm-6 col-xs-6 text-right d-flex align-items-center justify-content-center"
                                  style={{ gap: "40px" }}
                                >
                                  <IconButton
                                    aria-label="add"
                                    onClick={() => {
                                      if (+bigCount + +smallCount <5) {
                                        setBigCount(+bigCount + 1);
                                      }
                                      // setFieldValue("adultCount", bigCount);
                                    }}
                                    style={{
                                      border: "1px solid #6dd06d",
                                      width: "2rem",
                                      height: "2rem",
                                      borderRadius: "150rem",
                                      color: "#6dd06d",
                                    }}
                                  >
                                    <Add />
                                  </IconButton>
                                  <h4
                                    style={{
                                      color: "#6dd06d",
                                    }}
                                    className="my-auto"
                                  >
                                    {bigCount}
                                  </h4>

                                  <IconButton
                                    aria-label="remove"
                                    color="primary"
                                    onClick={() => {
                                      if (+bigCount - 1 < 1) {
                                        return false;
                                      } else {
                                        setBigCount(+bigCount - 1);
                                        // setFieldValue("adultCount", bigCount);
                                      }
                                    }}
                                    style={{
                                      border: "1px solid #6dd06d",
                                      width: "2rem",
                                      height: "2rem",
                                      borderRadius: "150rem",
                                      color: "#6dd06d",
                                    }}
                                  >
                                    <Remove />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-sm-12 col-xs-12 pr-0 type-holder">
                              <div className="row">
                                <div className="col-sm-6 col-xs-6">
                                  <h5 className="mt-4">کودک</h5>
                                </div>
                                <div
                                  className="col-sm-6 col-xs-6 text-right d-flex align-items-center justify-content-center"
                                  style={{ gap: "40px" }}
                                >
                                  <IconButton
                                    aria-label="add"
                                    onClick={() => {
                                      if (+bigCount + +smallCount <5) {
                                        setSmallCount(+smallCount + 1);
                                      }
                                      // setFieldValue("childCount", smallCount);
                                    }}
                                    style={{
                                      border: "1px solid #6dd06d",
                                      width: "2rem",
                                      height: "2rem",
                                      borderRadius: "150rem",
                                      color: "#6dd06d",
                                    }}
                                  >
                                    <Add />
                                  </IconButton>
                                  <h4
                                    style={{
                                      color: "#6dd06d",
                                    }}
                                    className="my-auto"
                                  >
                                    {smallCount}
                                  </h4>
                                  <IconButton
                                    aria-label="remove"
                                    onClick={() => {
                                      if (+smallCount - 1 < 0) {
                                        return false;
                                      } else {
                                        setSmallCount(+smallCount - 1);
                                        // setFieldValue("adultCount", smallCount);
                                      }
                                    }}
                                    style={{
                                      border: "1px solid #6dd06d",
                                      width: "2rem",
                                      height: "2rem",
                                      borderRadius: "150rem",
                                      color: "#6dd06d",
                                    }}
                                  >
                                    <Remove />
                                  </IconButton>
                                </div>
                              </div> 
                            </div> */}
                          </div>
                        </div>
                      </ClickAwayListener>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="col-12 col-lg-2" style={{ marginBlock: 13.5 }}>
                {isValid ? (
                  <Button
                    onClick={() => {
                      handleSubmit();
                      if (isMobile) {
                        dispatch(homepageActions.setMobileDialog(false));
                      }
                    }}
                    className="btn w-100 w-100"
                    style={{
                      backgroundColor: "#6dd06d",
                      height: "3.2em",
                      fontSize: 16,
                      borderRadius: 13,
                    }}
                  >
                    <span className="mx-auto my-auto text-white ">
                      جست و جو
                    </span>
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="btn w-100 bg-danger w-100"
                    disabled
                    style={{
                      height: "3.2em",
                      fontSize: 16,
                      borderRadius: 13,
                    }}
                  >
                    <span className="text-white mx-auto my-auto">جست و جو</span>
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default SearchSectionForms;
